import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ChevronRightIcon, PlusIcon, TrashIcon, ArrowPathIcon, ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/outline';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import { toast } from 'react-toastify';

const GestioneCampiPage = () => {
  const [loading, setLoading] = useState(true);
  const [penaliPresets, setPenaliPresets] = useState({
    penaleKasko: [],
    penaleRCA: [],
    penaleFurto: [],
    servizi: [],
    disponibilita: []
  });
  const [editingField, setEditingField] = useState(null);
  const [newValue, setNewValue] = useState('');

  // Carica i preset dei campi dal database
  useEffect(() => {
    const fetchPenaliPresets = async () => {
      setLoading(true);
      try {
        const response = await api.get('/offerte-vetture/config/campi-presets');
        if (response.data && response.data.presets) {
          setPenaliPresets(response.data.presets);
        }
      } catch (error) {
        console.error('Errore nel caricamento dei campi preimpostati:', error);
        toast.error('Errore nel caricamento dei campi preimpostati');
      } finally {
        setLoading(false);
      }
    };

    fetchPenaliPresets();
  }, []);

  // Gestisce l'aggiunta di un nuovo valore
  const handleAddValue = async (field) => {
    if (!newValue.trim()) {
      toast.error('Inserisci un valore valido');
      return;
    }

    // Verifica che il valore non sia già presente
    if (penaliPresets[field].includes(newValue)) {
      toast.error('Questo valore è già presente nella lista');
      return;
    }

    try {
      // Prepara i nuovi valori
      const updatedValues = [...penaliPresets[field], newValue];
      
      // Aggiorna il database
      await api.post('/offerte-vetture/config/campi-presets/update', {
        field,
        values: updatedValues
      });
      
      // Aggiorna lo stato locale
      setPenaliPresets({
        ...penaliPresets,
        [field]: updatedValues
      });
      
      toast.success('Valore aggiunto con successo');
      setNewValue('');
      setEditingField(null);
    } catch (error) {
      console.error('Errore nell\'aggiunta del valore:', error);
      toast.error('Errore nell\'aggiunta del valore');
    }
  };

  // Gestisce la rimozione di un valore
  const handleRemoveValue = async (field, value) => {
    // Non permettere di rimuovere il valore "Nessuna" per le penali
    if (value === 'Nessuna' && (field === 'penaleKasko' || field === 'penaleRCA' || field === 'penaleFurto')) {
      toast.warning('Il valore "Nessuna" non può essere rimosso');
      return;
    }

    try {
      // Prepara i nuovi valori
      const updatedValues = penaliPresets[field].filter(v => v !== value);
      
      // Aggiorna il database
      await api.post('/offerte-vetture/config/campi-presets/update', {
        field,
        values: updatedValues
      });
      
      // Aggiorna lo stato locale
      setPenaliPresets({
        ...penaliPresets,
        [field]: updatedValues
      });
      
      toast.success('Valore rimosso con successo');
    } catch (error) {
      console.error('Errore nella rimozione del valore:', error);
      toast.error('Errore nella rimozione del valore');
    }
  };

  // Gestisce lo spostamento in alto o in basso di un valore
  const handleMoveValue = async (field, value, direction) => {
    try {
      // Ottiene l'indice corrente del valore
      const currentIndex = penaliPresets[field].indexOf(value);
      
      // Se il valore non è trovato o se si tenta di spostare fuori dai limiti dell'array, non fare nulla
      if (
        currentIndex === -1 || 
        (direction === 'up' && currentIndex === 0) || 
        (direction === 'down' && currentIndex === penaliPresets[field].length - 1)
      ) {
        return;
      }
      
      // Crea una copia dell'array dei valori
      const updatedValues = [...penaliPresets[field]];
      
      // Rimuove il valore dalla posizione corrente
      updatedValues.splice(currentIndex, 1);
      
      // Calcola la nuova posizione
      const newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
      
      // Inserisce il valore nella nuova posizione
      updatedValues.splice(newIndex, 0, value);
      
      // Aggiorna l'ordine nel database
      await api.post('/offerte-vetture/config/campi-presets/reorder', {
        field,
        values: updatedValues
      });
      
      // Aggiorna lo stato locale
      setPenaliPresets({
        ...penaliPresets,
        [field]: updatedValues
      });
      
      toast.success(`Ordine aggiornato con successo`);
    } catch (error) {
      console.error('Errore nello spostamento del valore:', error);
      toast.error('Errore nello spostamento del valore');
    }
  };

  // Renderizza la sezione di modifica del campo
  const renderEditingSection = (field) => {
    const fieldTitles = {
      penaleKasko: 'Penale Kasko',
      penaleRCA: 'Penale RCA',
      penaleFurto: 'Penale Furto',
      servizi: 'Servizio Incluso',
      disponibilita: 'Stato Disponibilità'
    };

    return (
      <div className="mt-2 mb-4 p-3 bg-blue-50 rounded-md border border-blue-200">
        <h4 className="text-sm font-medium text-blue-700 mb-2">
          Aggiungi un nuovo valore per {fieldTitles[field]}
        </h4>
        <div className="flex space-x-2">
          <input
            type="text"
            value={newValue}
            onChange={(e) => setNewValue(e.target.value)}
            placeholder={
              field.includes('penale') 
                ? "Es. 250€ o 10%" 
                : field === 'servizi' 
                  ? "Nome del servizio" 
                  : "Stato (es. Stock, Ordine)"
            }
            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
          <button
            onClick={() => handleAddValue(field)}
            className="inline-flex items-center px-3 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Aggiungi
          </button>
          <button
            onClick={() => {
              setEditingField(null);
              setNewValue('');
            }}
            className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            Annulla
          </button>
        </div>
        {field.includes('penale') && (
          <p className="text-xs text-blue-600 mt-1">
            Usa il formato "250€" per valori in euro o "10%" per percentuali.
          </p>
        )}
      </div>
    );
  };

  // Renderizza un singolo valore con pulsanti per riordinare
  const renderValueItem = (field, value, index, totalItems) => {
    const isFirst = index === 0;
    const isLast = index === totalItems - 1;
    const isNessuna = value === 'Nessuna';
    const isPenaleField = field.includes('penale');

    return (
      <li key={value} className="px-4 py-3 flex justify-between items-center hover:bg-gray-50">
        <span className="text-gray-900">{value}</span>
        <div className="flex items-center space-x-2">
          {/* Pulsanti per il riordinamento */}
          <button
            onClick={() => handleMoveValue(field, value, 'up')}
            disabled={isFirst}
            className={`text-gray-500 hover:text-gray-700 ${isFirst ? 'opacity-30 cursor-not-allowed' : ''}`}
            title="Sposta su"
          >
            <ArrowUpIcon className="h-4 w-4" />
          </button>
          <button
            onClick={() => handleMoveValue(field, value, 'down')}
            disabled={isLast}
            className={`text-gray-500 hover:text-gray-700 ${isLast ? 'opacity-30 cursor-not-allowed' : ''}`}
            title="Sposta giù"
          >
            <ArrowDownIcon className="h-4 w-4" />
          </button>
          
          {/* Pulsante per rimuovere il valore */}
          {(!isPenaleField || !isNessuna) && (
            <button
              onClick={() => handleRemoveValue(field, value)}
              className="text-red-600 hover:text-red-900"
              title="Rimuovi valore"
            >
              <TrashIcon className="h-5 w-5" />
            </button>
          )}
        </div>
      </li>
    );
  };

  // Renderizza una carta per un tipo di campo
  const renderCard = (field, title, description) => {
    return (
      <div className="bg-white shadow overflow-hidden sm:rounded-lg h-full flex flex-col">
        <div className="px-4 py-5 sm:px-6 flex justify-between items-center bg-gray-50">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">{title}</h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">{description}</p>
          </div>
          <button
            onClick={() => setEditingField(field)}
            disabled={editingField === field}
            className={`inline-flex items-center px-3 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
              editingField === field ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
            }`}
          >
            <PlusIcon className="h-4 w-4 mr-1" />
            Aggiungi Valore
          </button>
        </div>
        
        {editingField === field && renderEditingSection(field)}
        
        <div className="flex-grow overflow-auto">
          <ul className="divide-y divide-gray-200">
            {penaliPresets[field]?.map((value, index) => 
              renderValueItem(field, value, index, penaliPresets[field].length)
            ) || <li className="px-4 py-3 text-gray-500">Nessun valore definito</li>}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <div className="overflow-x-auto bg-white shadow-md rounded-lg p-6">
      {/* Intestazione */}
      <div className="flex flex-col md:flex-row justify-between mb-6 items-start md:items-center space-y-4 md:space-y-0">
        <div>
          <h2 className="text-xl font-bold text-gray-800">Gestione Campi Predefiniti</h2>
          <p className="text-sm text-gray-500">Configura i valori predefiniti per i campi delle offerte vetture</p>
        </div>
        
        <div className="flex items-center gap-2">
          <Link
            to="/nlt/gestione-offerte-vetture"
            className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Torna alle Offerte
          </Link>
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            <ArrowPathIcon className={`h-5 w-5 ${loading ? 'animate-spin' : ''}`} />
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-10">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-3 text-gray-500">Caricamento configurazioni...</p>
        </div>
      ) : (
        <>
          {/* Sezione Penali - 3 schede in una riga */}
          <div className="mb-8">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Configurazione Penali</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {renderCard('penaleKasko', 'Penale Kasko', 'Valori predefiniti per la penale Kasko')}
              {renderCard('penaleRCA', 'Penale RCA', 'Valori predefiniti per la penale RCA')}
              {renderCard('penaleFurto', 'Penale Furto', 'Valori predefiniti per la penale Furto')}
            </div>
          </div>
          
          {/* Sezione Servizi e Disponibilità */}
          <div className="mb-8">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Configurazione Servizi</h3>
            <div className="grid grid-cols-1 gap-6">
              {renderCard('servizi', 'Servizi Inclusi', 'Elenco dei servizi inclusi nelle offerte')}
            </div>
          </div>
          
          {/* Nuova sezione per Disponibilità */}
          <div>
            <h3 className="text-lg font-medium text-gray-900 mb-4">Configurazione Stati Disponibilità</h3>
            <div className="grid grid-cols-1 gap-6">
              {renderCard('disponibilita', 'Stati Disponibilità', 'Valori possibili per lo stato di disponibilità della vettura')}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GestioneCampiPage; 